import dynamic from 'next/dynamic';
import {
  HomeGamesWrapper,
  JpWrapper,
  PopularGamesWrapper,
  RecordWinWrapper,
} from '@/widgets/game-sections/ui/styles';
import { PopularGamesSkeleton } from '@/widgets/game-sections/ui/popular-games-skeleton';
import { getBrandData } from '@/shared/hooks/useBrandTheme';

const DynamicHomeGameSections = dynamic(
  () => import('./home-game-sections').then((m) => m.HomeGameSections),
  {
    ssr: false,
    loading: () => {
      const jackpotEnabled = getBrandData().brandTheme.features.jackpot;

      return (
        <HomeGamesWrapper>
          <PopularGamesWrapper>
            <PopularGamesSkeleton />
          </PopularGamesWrapper>
          <RecordWinWrapper />
          {jackpotEnabled && <JpWrapper />}
        </HomeGamesWrapper>
      );
    },
  }
);

export { DynamicHomeGameSections };
